import { createWalletClient, custom } from 'viem'
import { mainnet } from 'viem/chains'
import { eip5792Actions } from 'viem/experimental'
import { ENTRYPOINT_ADDRESS_V07 } from 'permissionless'
import { paymasterActionsEip7677 } from 'permissionless/experimental'

export const getWalletClient = (provider) => {
	return createWalletClient({
		chain: mainnet,
		transport: custom(provider),
	}).extend(paymasterActionsEip7677(ENTRYPOINT_ADDRESS_V07)).extend(eip5792Actions());;
}
